var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ejs-grid',{ref:"grid",attrs:{"dataSource":_vm.data,"columns":_vm.tableColumns,"allowResizing":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }